// Angular
import { Component, Input } from '@angular/core';

interface IPrice { [key: string]: number; };

@Component({
    selector: 'delta-price',
    template: `
        <span *ngIf="oldPrice && getPriceDiff(oldPrice, price) !== 0"
            class="deltaPrice"
            [class]="classList"
            [ngClass]="{
                'negative': getPriceDiff(oldPrice, price) > 0,
                'positive': getPriceDiff(oldPrice, price) < 0
            }"
            [innerHTML]="getPriceDiff(oldPrice, price) | priceRealAmount: currency.code">
        </span>
    `,
    styles: [`
        .deltaPrice {
            display: block;
            text-align: right;
        }
        .center-price{
            text-align: center;
        }
        .deltaPrice.negative {
            color: red;
            font-size: 1rem;
        }
        .deltaPrice.positive {
            color: green;
            font-size: 1rem;
        }
    `]
})
export class DeltaPriceComponent {
    @Input()
    public price: IPrice;

    @Input()
    public oldPrice: IPrice;

    @Input()
    public currency: { code: string; decimals: number; };

    @Input()
    public classList: string;

     /** Get the delta of the old and current price after refresh */
    public getPriceDiff (oldPrice: IPrice, currentPrice: IPrice): number {
        const price: number = this.getPrice(currentPrice) - this.getPrice(oldPrice);
        return price;
    }

    private getPrice(price: IPrice): number {
        return price[this.currency.code] / Math.pow(10, this.currency.decimals);
    }
}